import React, {useEffect} from "react";
import "./style.css";
import animationData from "../../../../static/json/questionnaire/weight-loss/FoodScan.json";
import Lottie from "react-lottie";

export const FoodScan = ({
    clickNext = () => {},
    clickPrev = () => {},
    clicked,
    isCurPage,
    isMobile = false
                            }) => {

    useEffect(() => {
        if (clicked) {
            clickNext("");
        }
    }, [clicked]);
  return (
    <div className="food-scan">
      <div className="div">
        <div className="title">
          <p className="heading">One scan tells you everything</p>
        </div>

        <div className="overlap-wrapper">
            <Lottie
                options={{
                    autoplay: false,
                    animationData: animationData,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice'
                    }
                }}
                height={isMobile ? 480 : 600}
                width={isMobile ?335 : 420}
                isPaused={!isCurPage} />
        </div>
      </div>
    </div>
  );
};
